/* eslint-disable no-undef */

import styled from "@emotion/styled";
import classNames from "classnames";
import React, {
  useRef,
  useEffect,
  Ref,
  forwardRef,
  useImperativeHandle,
  useState,
} from "react";
import styles from "./styles.module.scss";
import { MyInfoWindow, ClusterBubble } from "./utils";
import logo from "../../images/map_icon.png";
import mapLine from "../../images/map_line.png";
import dawei from "../../images/danwei.png";

import jian from "../../images/jian.png";
import jiu from "../../images/jiu.png";
import wei from "../../images/wei.png";
import yuan from "../../images/yuan.png";
import { appConfigs } from "../../config";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const globalMap: any = TMap as any;

const MapLayout = styled.div``;
export const hex2rgb = (color: string, opacity = 1) => {
  if (!color) return;
  if (/^(rgb|RGB)/.test(color)) {
    let arr = color.toString().split(",");
    arr[3] = opacity + ")";
    return arr.join(",");
  }
  color = color.substring(1);
  color = color.toLowerCase();
  let b = [];
  for (let i = 0; i < 3; i++) {
    b[0] = color.substr(i * 2, 2);
    b[3] = "0123456789abcdef";
    b[1] = b[0].substr(0, 1);
    b[2] = b[0].substr(1, 1);
    b[20 + i] = b[3].indexOf(b[1]) * 16 + b[3].indexOf(b[2]);
  }
  return "rgba(" + b[20] + "," + b[21] + "," + b[22] + "," + opacity + ")";
};
export type TextTag = {
  id?: number;
  name: string;
  key?: string;
  position: [number, number];
  isBg?: boolean;
  isMain?: boolean;
};

export interface MapRef {
  /** 清空已选择的文件 */
  map: any;
  panTo: (lat: number, lng: number) => void;
  zoomTo?: (zoom: number) => void;
  removeAllMarkers: () => void;
  setMarkers: (isInit: boolean, mapDatas: any[]) => void;
}
type Props = {
  onZoom?: () => void;
  isFullScreen?: boolean;
  textTag?: TextTag[];
  iconTextTag?: TextTag[];
  geometry?: {
    paths: { lat: number; lng: number; height: number }[];
    styleId: string;
  }[];
  ellipseGeometry?: any[];
  onGeometryClick?: (dat?: TextTag) => void;
  zoom?: number;
  initialValues?: string[];
  cluster?: boolean;
  clusterLabel?: string;
};

function TMapComp(
  {
    isFullScreen,
    textTag,
    iconTextTag,
    geometry,
    onGeometryClick,
    zoom = 17.2,
    ellipseGeometry,
    initialValues,
    onZoom,
    cluster,
    clusterLabel,
  }: Props,
  ref: Ref<MapRef>
) {
  const mapRef = useRef(null);
  const map = useRef<any>(null);
  const [customMarkers, setCustomMarkers] = useState<any[]>([]);
  const centers = useRef<any[]>([]);
  const editorRef = useRef<any>(null);
  const markerCluster = useRef<any>(null);
  const setMarkers = (isInit: boolean, mapDatas?: any[]) => {
    const markerArr: any[] = [];

    if (mapDatas?.length) {
      mapDatas?.forEach((initialValue: any) => {
        const label = initialValue.label;
        const color = initialValue.color;
        const arrs = JSON.parse(initialValue.gisdata);
        const record = initialValue.record;
        const onClick = initialValue.onClick;
        const detailType = initialValue.detailType;
        if (arrs && arrs.length) {
          arrs.forEach((item: any, index: number) => {
            const type = item.type;
            let center = item.geometry.center;
            const geometry = item.geometry;
            if (center) {
              item.geometry.center = new globalMap.LatLng(
                center.lat,
                center.lng
              );
            } else {
              if (geometry.paths) {
                center = globalMap.geometry.computeCentroid(
                  geometry.paths.map(
                    (item: any) => new globalMap.LatLng(item.lat, item.lng)
                  )
                );
              }
            }
            const bgColor = color
              ? ` linear-gradient(90deg, rgba(0, 216, 247, 0) 0%, ${color} 100%)`
              : `linear-gradient(90deg, rgba(0, 216, 247, 0) 0%, #00afed 100%)`;
            // 在形心位置添加文本标注
            let view;
            if (label && center) {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              view = new MyInfoWindow({
                map: map.current,
                position: new globalMap.LatLng(center.lat, center.lng),
                noBackground: true,
                content: `
                <div style="
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  align-items: center;
                ">
                  <div style="
                  position: relative;
                  ">
                      <img src=${dawei} width="30" style="
                      position: absolute;
                      top: 70px;
                      width: 40px;
                      " />
                      <span style="
                        width: 290px;
                        height: 21px;
                        font-size: 20px;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: #FFFFFF;
                        line-height: 182px;
                        border: 2px solid ${color || "#0C709D"};
                        border-radius: 20px;
                        padding: 2px 16px;
                        padding-left: 48px;
                        cursor: pointer;
                        background: ${bgColor}
                      ">${label}</span>
                  </div>
                  <img src=${mapLine} width="30" style="
                      position: relative;
                      top: -78px;
                      height: 33px;
                      width: 8px;
                  " />
                  <img src=${logo} width="30" style="
                   position: relative;
                    top: -84px;
                    width: 22px;
                  "/>
                </div>`,
              });
              view.dom.addEventListener("click", (e: any) => {
                onClick?.(record, detailType);
              });
              if (!isInit) {
                // markerArr.push(labelMarker);
                markerArr.push(view);
                // markerArr.push(marker);
              }
            }

            let tempMarker;
            switch (type) {
              case "polygon": {
                geometry.styleId = !color ? "default" : "polygon";
                tempMarker = new globalMap.MultiPolygon({
                  map: map.current,
                  styles: {
                    //多边形的相关样式
                    polygon: new globalMap.PolygonStyle({
                      color: hex2rgb(color, 0.2),
                      borderColor: color, //边线颜色
                    }),
                  },
                  geometries: [geometry],
                });
                break;
              }
              case "polyline": {
                geometry.paths = geometry.paths.map(
                  (item: any) => new globalMap.LatLng(item.lat, item.lng)
                );
                tempMarker = new globalMap.MultiPolyline({
                  map: map.current,
                  geometries: [geometry],
                });
                color &&
                  tempMarker.setStyles({
                    polygon: new globalMap.PolygonStyle({
                      color: hex2rgb(color, 0.2),
                      borderColor: color, //边线颜色
                    }),
                  });
                break;
              }
              case "ellipse": {
                tempMarker = new globalMap.MultiEllipse({
                  map: map.current,
                  geometries: [geometry],
                });
                break;
              }
              case "rectangle": {
                geometry.styleId = !color ? "default" : "rectangle";
                tempMarker = new globalMap.MultiRectangle({
                  map: map.current,
                  styles: {
                    //多边形的相关样式
                    rectangle: new globalMap.RectangleStyle({
                      color: hex2rgb(color, 0.2),
                      borderColor: color, //边线颜色
                    }),
                  },
                  geometries: [geometry],
                });
                break;
              }
              case "circle": {
                geometry.styleId = !color ? "default" : "circle";
                tempMarker = new globalMap.MultiCircle({
                  map: map.current,
                  styles: {
                    //多边形的相关样式
                    circle: new globalMap.CircleStyle({
                      color: hex2rgb(color, 0.2),
                      borderColor: color, //边线颜色
                    }),
                  },
                  geometries: [geometry],
                });
                break;
              }
              case "marker": {
                geometry.position = new globalMap.LatLng(
                  geometry.position.lat,
                  geometry.position.lng
                );
                tempMarker = new globalMap.MultiMarker({
                  map: map.current,
                  styles: {
                    yuan: new globalMap.MarkerStyle({
                      width: 25,
                      height: 25,
                      anchor: { x: 16, y: 32 },
                      src: yuan,
                      // src: "https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/markerDefault.png",
                    }),
                    jiu: new globalMap.MarkerStyle({
                      width: 25,
                      height: 35,
                      anchor: { x: 16, y: 32 },
                      src: jiu,
                      // src: "https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/markerDefault.png",
                    }),
                    wei: new globalMap.MarkerStyle({
                      width: 25,
                      height: 35,
                      anchor: { x: 16, y: 32 },
                      src: wei,
                      // src: "https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/markerDefault.png",
                    }),
                    jian: new globalMap.MarkerStyle({
                      width: 25,
                      height: 35,
                      anchor: { x: 16, y: 32 },
                      src: jian,
                      // src: "https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/markerDefault.png",
                    }),
                  },
                  geometries: [geometry],
                });
                break;
              }
              default: {
                break;
              }
            }
            if (center && cluster) {
              centers.current.push({
                center,
                id:
                  center.lat + "-" + center.lng + "-" + centers.current.length,
                marker: tempMarker,
                view: view,
              });
            }
            if (!isInit && tempMarker) {
              markerArr.push(tempMarker);
            }
          });
        }
      });
    }
    if (cluster) {
      if (!markerCluster.current) {
        if (centers.current?.length) {
          markerCluster.current = new globalMap.MarkerCluster({
            id: "cluster",
            map: map.current,
            enableDefaultStyle: false, // 关闭默认样式
            minimumClusterSize: 3,
            geometries: centers.current.map((item, index) => {
              const { center, id, markerId, view } = item;
              return {
                // 点数组
                position: new globalMap.LatLng(center.lat, center.lng),
                id,
              };
            }),
            zoomOnClick: true,
            gridSize: 120,
            averageCenter: false,
          });
          var clusterBubbleList: any[] = [];
          var markerGeometries: any[] = [];
          var marker: any = null;
          // 监听聚合簇变化
          markerCluster.current.on("cluster_changed", function () {
            // 销毁旧聚合簇生成的覆盖物
            if (clusterBubbleList.length) {
              clusterBubbleList.forEach(function (item) {
                item.destroy();
              });
              clusterBubbleList = [];
            }
            markerGeometries = [];
            centers.current.forEach((center) => {
              const { view, marker } = center;
              marker?.setVisible?.(true);
              view?.setVisible?.(true);
            });
            // 设置为可见， 然后再隐藏对应的数据
            // 根据新的聚合簇数组生成新的覆盖物和点标记图层
            var clusters = markerCluster.current.getClusters();
            clusters.forEach(function (item: any) {
              if (item.geometries.length > 1) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                let clusterBubble = new ClusterBubble({
                  map: map.current,
                  position: item.center,
                  content: item.geometries.length + (clusterLabel || ""),
                });
                clusterBubble.on("click", () => {
                  map.current.fitBounds(item.bounds);
                });
                clusterBubbleList.push(clusterBubble);
                item.geometries.forEach((item: any) => {
                  const { id } = item;
                  const arrs = id.split("-");
                  const index = arrs[arrs.length - 1];
                  const info = centers.current[index];
                  // markerId: tempMarker.id,
                  // view: view,
                  if (info) {
                    const { view, marker } = info;
                    marker?.setVisible?.(false);
                    view?.setVisible?.(false);
                    // marker?.destroy?.();
                    // view?.destroy?.();
                  }
                });
              } else {
                markerGeometries.push({
                  position: item.center,
                });
              }
            });

            if (marker) {
              // 已创建过点标记图层，直接更新数据
              marker.setGeometries(markerGeometries);
            } else {
              // 创建点标记图层
              marker = new globalMap.MultiMarker({
                map: map.current,
                styles: {
                  default: new globalMap.MarkerStyle({
                    width: 0,
                    height: 0,
                    display: "none",
                    opacity: 0,
                    anchor: {
                      x: 17,
                      y: 21,
                    },
                    // src: "https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/marker_blue.png",
                  }),
                },
                geometries: markerGeometries,
              });
            }
          });
        }
      } else {
        markerCluster.current.updateGeometries(
          centers.current.map((item) => {
            const { center, id } = item;
            return {
              // 点数组
              position: new globalMap.LatLng(center.lat, center.lng),
              id,
            };
          })
        );
      }
    }
    setCustomMarkers([...markerArr]);
  };
  useEffect(() => {
    if (mapRef.current) {
      // 114.06455, 22.54846
      let center = new globalMap.LatLng(31.644232, 118.550572);
      if (appConfigs.position) {
        center = new globalMap.LatLng(
          appConfigs.position[1],
          appConfigs.position[0]
        );
      }
      //定义map变量，调用 TMap.Map() 构造函数创建地图

      map.current = new globalMap.Map(mapRef.current, {
        center: center, //设置地图中心点坐标
        zoom: zoom, //设置地图缩放级别
        pitch: 0, //设置俯仰角
        // rotation: 0, //设置地图旋转角度
        mapStyleId: "style1",
        viewMode: "2D",
        baseMap: {
          // 设置卫星地图
          // type: "satellite",
        },
      });
      map.current.on("zoom", () => {
        onZoom?.();
        // const zoom = map.current.getZoom();
        // console.log("++++++++++++++++++++" + map.current.getZoom());
        // if (zoom < 10) {
        //   customMarkers.forEach((view) => {
        //     view.target.style.display = "none";
        //   });
        // } else {
        //   customMarkers.forEach((view) => {
        //     view.target.style.display = "block";
        //   });
        // }
      });
      const polygon = new globalMap.MultiPolygon({
        map: map.current,
      });
      if (ellipseGeometry) {
        new globalMap.MultiEllipse({
          map: map.current,
          geometries: ellipseGeometry,
        });
      }
      setMarkers(true, initialValues);
      textTag?.forEach((tag) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const view = new MyInfoWindow({
          map: map.current,
          position: new globalMap.LatLng(tag.position[1], tag.position[0]),
          content: tag.name,
          isMain: tag.isMain,
        });
        if (tag?.isBg === false) {
          view.dom.style.backgroundColor = "transparent";
          view.dom.style.border = "none";
        }

        view.dom.addEventListener("click", (e: any) => {
          onGeometryClick?.(tag);
          if (e.target.textContent === "雨山经济开发区") {
            e.target.style.display = "none";
            iconTextTag?.forEach((iconTag) => {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              const view = new MyInfoWindow({
                map: map.current,
                position: new globalMap.LatLng(
                  iconTag.position[1],
                  iconTag.position[0]
                ),
                content: iconTag.name,
              });
              if (iconTag?.isBg === false) {
                view.dom.style.backgroundColor = "transparent";
                view.dom.style.border = "none";
              }
            });
          }
        });
      });
      polygon.updateGeometries(geometry);
      //if (ellipseGeometry) {
      // console.log("ellipseGeometry", ellipseGeometry);
      // console.log("ellipse", ellipse.setGeometries);
      // console.log("----------------");
      // ellipse.setGeometries(ellipseGeometry);
      // }
      // map.current.panTo(new globalMap.LatLng(22.54846, 114.06455));
    }

    return () => {
      map.current?.destroy?.();
    };
  }, [textTag, geometry, ellipseGeometry]);

  useImperativeHandle(ref, () => ({
    map: map.current,
    panTo: (lat: number, lng: number) => {
      map.current?.panTo(new globalMap.LatLng(lat, lng), {
        duration: 2000,
      });
    },
    zoomTo: (zoom: number) => {
      map.current.zoomTo(zoom, {
        duration: 2000,
      });
    },
    removeAllMarkers: () => {
      customMarkers.forEach((item: any) => {
        if (item) {
          item.setMap(null);
          item = null;
        }
      });
    },
    setMarkers: setMarkers,
  }));

  return (
    <MapLayout>
      <div>
        <div
          ref={mapRef}
          className={classNames({
            [styles.fullScreen]: isFullScreen,
          })}
        ></div>
      </div>
    </MapLayout>
  );
}

export default React.memo(
  forwardRef<MapRef, Props>(TMapComp),
  (prevProps, nextProps) => {
    return (
      prevProps.initialValues?.length === nextProps.initialValues?.length &&
      prevProps.textTag?.length === nextProps.textTag?.length
    );
  }
);
